import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import {ModalType} from "data/enums";
import type {IModalsStore, IModalPayload} from "data/stores/modals/modals.store";
import type {ILocalizationStore} from "data/stores/localization/localization.store";

export interface IModalErrorController extends ViewController {
	i18n: ILocalizationStore;

	get isOpen(): boolean;
	get modalContent(): IModalPayload | null;
	get message(): string;

	close: () => void;
}

@injectable()
export class ModalErrorController implements IModalErrorController {
	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.ModalsStore) private readonly _modalsStore: IModalsStore
	) {
		makeAutoObservable(this);
	}

	get isOpen(): boolean {
		return this._modalsStore.modal === ModalType.ERROR;
	}

	get modalContent() {
		return this._modalsStore.modalContent;
	}

	get message() {
		const messageKey = this.modalContent?.message || "registration.error.common";
		return this.i18n.t(messageKey, this.errorMessages[messageKey] || messageKey);
	}

	close = () => {
		this._modalsStore.hideModal();
	};

	get errorMessages() {
		return {
			'registration.error.email_is_not_unique': 'This email is already registered to the game. Please Login',
			'registration.error.display_name_is_not_unique': "This display name is already registered to the game. Please Login",
			'registration.error.not_found': "User not found",
			'registration.error.terms_not_accepted': "Please accept Terms & Conditions",
			'registration.error.common': "Something went wrong. Please try again",
		} as Record<string, string>
	}
}
